import React from "react";
import { connect } from "react-redux";
import { _Navbar, _Logo, _NavItem } from "./styled-navbar";
import { _Flex } from "../common/styled-flex";
import { _Button } from "../common/styled-buttons";
import theme from "../../styles/theme";
import { setSelectedMenu, getInterfaceMode } from "../../core/ui";

import Export from "../export";
import Download from "../export/download";

const Navbar = ({ setSelectedMenu, interfaceMode }) => {
  return (
    <_Navbar>
      {interfaceMode !== "rootsgifts" && (
        <_Logo href="https://familytreeprints.com">
          <img src="https://cdn.shopify.com/s/files/1/1887/3517/files/FTPrints_Logo_400px_2x_b6eb6f60-6a65-4288-829b-24f31ce3fea9_400x200.png?v=1490939637" />
        </_Logo>
      )}

      {interfaceMode === "rootsgifts" && (
        <_Logo href="https://rootsgifts.com">
          <img
            src="https://cdn.shopify.com/s/files/1/2386/2435/files/roots-gifts-logo-color-3_360x@2x.png?v=1506467022"
            style={{ width: 200 }}
          />
        </_Logo>
      )}

      <_Flex />

      {interfaceMode === "prince" && (
        <_NavItem>
          <Download scale={1.5} />
        </_NavItem>
      )}
      {interfaceMode === "prince" && (
        <_NavItem>
          <Download text="Download High-Res" scale={4.0} />
        </_NavItem>
      )}
      {(interfaceMode === "prince" || interfaceMode === "json") && (
        <_NavItem>
          <Download text="Download JSON" type="json" />
        </_NavItem>
      )}
      {interfaceMode === "prince" && (
        <_NavItem>
          <Download text="Download SVG" type="svg" />
        </_NavItem>
      )}
      {interfaceMode !== "rootsgifts" && (
        <_NavItem>
          <_Button
            unstyled
            href="https://familytreeprints.com/blogs/tutorials"
            target="_blank"
          >
            View Tutorials
          </_Button>
        </_NavItem>
      )}

      {interfaceMode !== "rootsgifts" && (
        <_NavItem>
          <_Button
            background="#929e84"
            onClick={() => setSelectedMenu("import")}
          >
            Import Family Names
          </_Button>
        </_NavItem>
      )}

      <_NavItem>
        <Export />
      </_NavItem>
    </_Navbar>
  );
};

const mapStateToProps = (state) => ({
  interfaceMode: state.ui.interfaceMode,
});

const mapDispatchToProps = Object.assign({ setSelectedMenu });

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar/index.js